/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const FACEBOOK = 'https://www.facebook.com/Recreation.gov';
export const INSTAGRAM = 'https://www.instagram.com/recreation_gov';
export const PINTEREST = 'https://www.pinterest.com/recreationgov';
export const TWITTER_X = '';

// cSpell:ignore PINTEREST
